import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { ListStb } from '../model/list-stb';
import { ListProductsale } from '../model/list-productsale';
import { CustomerService } from '../model/customer-service';
import { Customer } from '../model/customer';
import { AuthenticationService } from '../_services/authentication.service';
import  conf from '../_models/conf.json';

@Injectable({
  providedIn: 'root'
})
export class ApiPartnerService {

  public conf = conf;
  //public urlApi = 'http://localhost/api-open-content/frontend/web/index.php/';
  //public urlApi = 'http://localhost:8000/index.php/';
  public urlApi = conf.urlApi;

  //public urlApi = 'http://localhost:8000/index.php/';
  //public urlApi = 'http://localhost:8080/index.php/';
  
  // Staging 
  // public urlApi = 'http://b2b-api-dev.mncplaymedia.com/frontend/web/index.php/';
  // public urlApi = 'https://b2b-api-dev.mncplay.id/frontend/web/index.php/';

  // production  Local
  // public urlApi = 'http://b2b-api.mncplaymedia.com/frontend/web/index.php/';

  // production  Public
   //public urlApi = 'https://b2b-api.mncplay.id/frontend/web/index.php/';
  
  
  constructor(private http: HttpClient,private authenticationService: AuthenticationService) { 
    
  }
 
 httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  _httpOptions()
  {
    
    const currentUser = this.authenticationService.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn = currentUser && currentUser.access_token;
    // console.log(isLoggedIn);

    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  _httpUploadOptions()
  {
    
    const currentUser = this.authenticationService.currentUserValue;
    // console.log(currentUser);
    const isLoggedIn = currentUser && currentUser.access_token;
    // console.log(isLoggedIn);

    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
             // 'Content-Type': 'multipart/form-data;',
              'Authorization': 'Bearer '+currentUser.access_token,
             // 'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }else{
      return {
            headers: new HttpHeaders({
             // 'Content-Type': 'multipart/form-data;',
             // 'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  _outhttpOptions()
  {
    return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer MSzNT2Jk-mILyGIVk9lcjxHUc2HKfi1L',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
  } 

   _billhttpOptions()
  {
    return {
            headers: new HttpHeaders({
              'Content-Type': 'application/xhtml+xml',
              'Authorization': 'Bearer MSzNT2Jk-mILyGIVk9lcjxHUc2HKfi1L',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
  } 
  
  _httpOptionsparams(params:any)
  {
    
    const currentUser = this.authenticationService.currentUserValue;
    console.log(currentUser);
    const isLoggedIn = currentUser && currentUser.access_token;
    console.log(isLoggedIn);

    if ( isLoggedIn )
    {
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+currentUser.access_token,
              'referer-policy': 'no-referrer-when-downgrade'
            }),
            params: params
          };
    }else{
      return {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'referer-policy': 'no-referrer-when-downgrade'
            })
          };
    }
  } 

  // GET List STB
  GetStb(): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostActivatestb(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/activatestb/'+id, JSON.stringify({}), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostActivatestball(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'opencontent/orders/activatestball/'+id, JSON.stringify({}), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostRemovestb(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/removestb/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostRemovestbdraft(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/removestbdraft/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListallstb(param: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/listallstb'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListstbpartner(param: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/liststbpartner'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  GetListstbavail(param: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/liststbavail'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  PostAddBulky(param: any): Observable<ListStb> {
    return this.http.post<any>(this.urlApi + 'operation/manualscripts/addacountbulky', JSON.stringify(param), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

   PostAddActivationBulky(param: any): Observable<ListStb> {
    return this.http.post<any>(this.urlApi + 'operation/manualscripts/activationbulky', JSON.stringify(param), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  

  
  PostListstbavail(param: any): Observable<ListStb> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/stbavail', JSON.stringify(param), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }



  GetReleasestblist(param: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/releasestblist'+param, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetReleasestbdetail(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/stbs/releasestbdetail/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListreleasedraft(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/stbs/listreleasedraft/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListreleasesubmit(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/stbs/listreleasesubmit/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListstbpending(param: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/liststbpending'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostChangestbsts(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/changestbsts/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostReqreleasestb(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/reqreleasestb', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostUploadrelease1(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/uploadrelease1/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostRemovereleasestbdraft(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/removereleasestbdraft/'+id, {}, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostSubmitreleasestb(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/submitreleasestb/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostApprovestb(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/approvestb/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListStb(param: any): Observable<ListStb> {
    return this.http.get<any>(this.urlApi + 'partner/stbs'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListStbwic(param: any): Observable<ListStb> {
    return this.http.get<any>(this.urlApi + 'partner/stbs/stbwic'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListStbcallcenter(param: any): Observable<ListStb> {
    return this.http.get<any>(this.urlApi + 'partner/stbs/stbcallcenter'+param,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Search STB by sn
  SearchStb(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/stbs/searchby',JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

// GET List STB
  GetStbUsed(params: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/used')
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


// GET Detail STB
  GetViewStb(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/viewstb/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET Singleview STB
  GetSingleview(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/stbs/singleview/'+id)
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List ProductATV
  GetProductatv(params): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/productsales/productatv'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Product
  GetProduct(params: any): Observable<ListProductsale> {
    return this.http.get<ListProductsale>(this.urlApi + 'partner/productsales'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetGroupProduct(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/productsales/groupproduct'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostListProduct(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'partner/productsales/listall', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostCheckpcode(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'partner/productsales/checkpcode', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateproduct(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'partner/productsales/createproduct', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  GetProducttype(): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/productsales/producttypex',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  // GET Product Id
  GetProductsale(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/productsales/viewproduct/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  // by partner login service quota
  GetPartnerServiceQuota(params: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/partners/servicequota'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  // by admin partner service quota/id
  /* OLD 
  GetViewServiceQuota(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/partners/viewservicequota/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  */

  GetViewServiceQuota(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/partners/viewservicequotabypartner/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

    
  GetViewpartnerstb(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/viewpartnerstb/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetViewpartnerstb2(id: any, qs): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/viewpartnerstb2/'+id + qs, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
    
  // partner service quota
  GetPartnerServiceTrx(data: any): Observable<ListStb> {
    return this.http.post<ListStb>(this.urlApi + 'partner/partners/servicetrx/'+data.productid,data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  // load service detail
  GetServicedetail(id: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/partners/servicedetail/'+id,{}, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  // GetServicelistpartner(id: any): Observable<any> {
  //   return this.http.get<any>(this.urlApi + 'partner/partners/servicelistpartner/'+id, this._httpOptions())
  //   .pipe(
  //     retry(1),
  //     catchError(this.errorHandl)
  //   )
  // }
  GetServicelistpartner(data:any): Observable<any> {
    console.log(data);
    let params = new HttpParams().set('productid',data.productid);
    // let params = new HttpParams();

    // for(let key in data){
    //   params.set(key, data[key]) 
    // }
    // console.log(params)

    return this.http.get<any>(this.urlApi + 'partner/partners/servicelistpartner/'+data.partnerid,this._httpOptionsparams(params))
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetServicelistall(data: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/servicelistall/'+data.producttype, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


 // GetQuotaPrepaidProductpartner
 GetQuotaPrepaidProduct(qs): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/servicequota'+qs,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  } 
 GetQuotaPrepaidProductcheck(qs): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/servicequotacheck'+qs,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  } 

  // Update Product Id
  SetUpdateproductsale(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/productsales/updateproduct/'+data.id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  // Delete Product Id
  SetDeleteproductsale(id: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/productsales/deleteproduct/'+id,{},this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  Getprovisioningchannel(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'partner/productsales/getprovisioningchannel', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  Getproductchannel(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'partner/productsales/getproductchannel', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // Post Customer

  PostCustomerSuspend(data: any): Observable<any> {
      return this.http.post<any>(this.urlApi + 'partner/customers/suspend', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }

  PostCustomerReconnect(data: any): Observable<Customer> {
      return this.http.post<any>(this.urlApi + 'partner/customers/reconnect', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )

    }  


  GetCustomersuspendnote(data: any):Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/notesuspend/' +data, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostCustomer(data: any): Observable<Customer> {
      return this.http.post<Customer>(this.urlApi + 'partner/customers/add', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }

  // Post Change Device
  PostChangePackage(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/changepackage', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Post Change Device
  PostChangePackagePrepaid(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/changepackageprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Get Customer
  GetViewCustomer(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetCustomerService(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/listallservice' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetViewCustomeratvorder(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/atvorder/' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // Get Customer
  GetViewCustomerArray(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/detail/' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  // Get Customer
  GetViewless(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/viewless/' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  updatecustomer(id: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/updatecustomer/' +id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCostumerstatus(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/updatestatus', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostAvailabletopostpaid(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'billing/customerbills/availabletopostpaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  Changebillingcust(id: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/changebillingcust/' +id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  Postprepaidtopostpaid(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'billing/customerbills/prepaidtopostpaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  Postcheckingpostpaidservice(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'billing/customerbills/checkingpostpaidservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }



  // GET List Customer
  GetCustomers(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Rekap Data
  GetRekapdata(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/rekapdata'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  //http://localhost/api-open-content/frontend/web/index.php/partner/customers/rekapdata?limit=100

  // GET List All Customer
  GetListallcust(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallcust'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List All Customer
  GetListallcustasarray(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallcustarray'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListalleapapproval(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallecustapproval'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List All Customer
  GetSubServiceCustomer(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallsubservice'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  
   GetListallapapproval(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallcustapproval'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  Getverifiedcustomer(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallcustverified'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }



/* store */
GetViewStoreOrder(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'storeplaybox/actions/detorder/'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  Listallcustreport(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listallcustreport'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  Listallcustfilter(data: any): Observable<Customer> {
    console.log(data);
    return this.http.post<Customer>(this.urlApi + 'partner/customers/listallcustfilter', JSON.stringify(data) ,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Customer Facroty Reset
  GetListcustfactoryreset(id: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/listfactoryreset/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Customer Facroty Reset
  PostCustfactoryreset(id: any, data: any): Observable<Customer> {
    return this.http.post<Customer>(this.urlApi + 'partner/customers/factoryreset/'+id, JSON.stringify(data) ,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostApprovalagree(id: any, data: any): Observable<Customer> {
    return this.http.post<Customer>(this.urlApi + 'partner/customers/approvalagree/'+id, JSON.stringify(data) ,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostApprovalecommerceagree(id: any, data: any): Observable<Customer> {
    return this.http.post<Customer>(this.urlApi + 'partner/customers/approvalecommerceagree/'+id, JSON.stringify(data) ,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  

  
  Getapprovalreason(id: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/approval/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  Getecommerceapprovalreason(id: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/approvalecommerce/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Customer Active
  GetCustomerActive(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/active'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  // GET List Customer Active
  GetCustomerActivepartner(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'partner/customers/activepartner'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET List Layanan
  GetServices(data: any): Observable<CustomerService> {
    return this.http.get<CustomerService>(this.urlApi + 'partner/customers/services/'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  
  GetServiceHistory(data: any): Observable<CustomerService> {
    return this.http.get<CustomerService>(this.urlApi + 'partner/customerservices/loghistory/'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetPrepaidinvoiceHistory(data): Observable<CustomerService> {
    return this.http.get<CustomerService>(this.urlApi + 'billing/histories/prepaidinvoice?id='+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // POST LAYANAN
  PostService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/service', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // POST LAYANAN
  
  PostOrderServicePrepaid(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/orderserviceprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostOrderServicePrepaidpgw(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/orderserviceprepaidpgw', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetOrderServiceCustomer(data): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/orderservices/'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  PostServicePrepaid(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/serviceprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // POST LAYANAN
  DeleteService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/deleteservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  DeleteServicePrepaid(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/deleteserviceprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  DeleteServicePrepaidurgent(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/deleteserviceprepaidurgent', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  DeleteOrderServicePrepaid(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/deleteorderserviceprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // POST LAYANAN
  ActivationService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'operation/provisionings/activationservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // single activation 
  ATVActivationService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'operation/provisioningatvs/addpackage', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  REATVActivationService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'operation/provisioningatvs/readdpackage', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  reloadSubService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'operation/customerservices/reloadservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }



  ATVShowUserId(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisioningatvs/showuserid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // list notification service 
  Getnotificationservice(data:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'operation/customerservices/notification'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  Getpartnernotification(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/customerservices/partnernotification', JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostAddNotification(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/customerservices/addnotification' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostAddCronNotification(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/customerservices/addcronnotification' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostSendNotification(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/notifications/directsend' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  PostAddActiveFutureaction(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/customerservices/activefutureaction' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostRemoveFutureaction(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/customerservices/removefutureaction' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostCancelcustomer(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customers/updatestatus' , JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // checkout order baru
  ATVCheckoutService(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customerservices/addonservice' , JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

// checkout order baru
  CheckoutServicePGW(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customerservices/checkoutservicepgw' , JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // checkout service pospaid
  CheckoutServicePospaid(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'partner/customerservices/checkoutservicepospaid' , JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
 // POST LAYANAN PREPAID
  ActivationServicePrepaid(data: any): Observable<CustomerService> {
    return this.http.post<any>(this.urlApi + 'operation/customeractions/atvactivationcustomerservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // POST LAYANAN
  DeactivationService(data: any): Observable<CustomerService> {
    return this.http.post<CustomerService>(this.urlApi + 'partner/customers/deactivationservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // Post Provisioning
  PostSuspend(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisionings/suspend', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Post Provisioning
  PostSubscription(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisionings/activation', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Post Provisioning
  PostUnSubscription(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisionings/unsubscription', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Post Provisioning
  PostReconnect(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisionings/reactivation', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }


  // partner
  GetListPartner(param: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/companies'+param,this._httpOptions())
   .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  GetPartnername(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/companies/viewpartnername/'+id,this._httpOptions())
   .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  /*Order Stb */
  GetPartner(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/partner', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetViewpartnerless(param:any = ''): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/viewpartnerless'+param, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetViewpartnerdetail(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/viewpartnerdetail/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetPartnerwtowic(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/partnerwtowic', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetPartnerwitwic(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/partnerwitwic', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetPartnersuperbranch(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/partnersuperbranch', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetView(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/view/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetViewliststb(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/viewliststb/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetViewliststbdraft(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/viewliststbdraft/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetOrderStb(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/orderstb', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostUploadOrder(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/upload', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetStbValid(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/stbvalid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetStbInvalid(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/stbinvalid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetVieworderstb(id: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.get<any>(this.urlApi + 'opencontent/orders/getorderstb/'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostUploadOrderReupload(data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/reupload', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostUploadnew(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/uploadnew/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostUploaddraft(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/uploaddraft/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostUploaddraftpaired(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/uploaddraftpaired/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostReuploadnew(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/reuploadnew/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostReuploaddraft(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/reuploaddraft/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListorder(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/listorder'+params, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListorderstbonly(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/listorderstbonly'+params, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListorderappsonly(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/listorderappsonly'+params, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListorderdetail(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orders/listorderdetail'+id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  ChangePartnerService(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'opencontent/orders/changepartnerservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostStatuspaid(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'opencontent/orders/setstatuspaid/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostStatusorder(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'opencontent/orders/setstatusorder/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostSubmitdraft(id: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'opencontent/orders/submitdraft/'+id, JSON.stringify({}), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateOrderstb(data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/createorder', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateOrderpaired(data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/createorderpaired', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateOrderstbonly(data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/createorderstbonly', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostCreateOrderappsonly(data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orders/createorderappsonly', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  
  
  /*END ORDER STB */
  /*ORDER SERVICE */
  GetOrderService(params): Observable<any> {
    return this.http.get<any>(this.urlApi + 'opencontent/orderservices/listbatchservice'+params, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
      )
    }

  PostCreateOrderService(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'opencontent/orderservices/createbatchservice', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  ViewOrderService(data: any): Observable<any> {
    // console.log(this.urlApi + 'opencontent/orderservices/viewbatchservice/'+data)
    return this.http.get<any>(this.urlApi + 'opencontent/orderservices/viewbatchservice/'+data, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  /*END ORDER SERVICE */

  GetBillingtype(): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'master/billingtypes',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetPartnertype(): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'master/partnertypes',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetProductsource(params:any = ''): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'master/productsources'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  GetProvisioning(data:any): Observable<ListStb> {
  console.log(data);
    // let params = new HttpParams().set('productsource',data.productsource);
    let params = new HttpParams();

    for(let key in data){
      params.set(key, data[key]) 
    }

    return this.http.get<ListStb>(this.urlApi + 'operation/provisionings',this._httpOptionsparams(params))
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetSourceProvisioning(data: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'operation/provisionings'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetListprovisioning(data: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'operation/provisioningatvs/listprovisioning'+data,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetDetailprovisioning(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'operation/provisioningatvs/detailprovisioning/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetChannelbyproduct(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisioningatvs/getchannelvplus',JSON.stringify(data),this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateProvisioning(data: any): Observable<any> {
    // console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'operation/provisioningatvs/addprovisioning', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostEditProvisioning(params: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'operation/provisioningatvs/updateprovisioning/'+params, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Get Report Partner
  GetReportPartner(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET Detail Partner
  GetEditPartner(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/partners/viewreportpartner/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // GET Paging Report Partner
  GetReportPage(param: any): Observable<any>{
    return this.http.get<any>(this.urlApi + 'partner/partners'+param,this._httpOptions())
  }



  /* Customer Status Action */
  // prepaid
  PostActionActivationPrepaid(data: any)
  {
    return this.http.post<any>(this.urlApi + 'operation/customeractions/activationprepaid', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  } 

  // Get User List
  GetUserlist(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'usermanagement/users'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetUserSubPartner(id:any,params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/subpartner/'+id+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  // Get User
  GetUser(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'usermanagement/users/getuser/'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  /* ATV */
  PrepaidActivation(data: any)
  {
    //return this.http.post<any>(this.urlApi + 'operation/customeractions/activationprepaid', JSON.stringify(data), this._httpOptions())
    
    return this.http.post<any>(this.urlApi + 'operation/customeractions/activationprepaidprov', JSON.stringify(data), this._httpOptions())
  .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostATVCheckSN(data: any)
  {
    return this.http.post<any>(this.urlApi + 'operation/customeractions/atvcheckingsn', JSON.stringify(data), this._httpOptions())
    .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostATVServiceActivation(data: any)
  {
    return this.http.post<any>(this.urlApi + 'operation/customeractions/atvserviceactivation', JSON.stringify(data), this._httpOptions())
    .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  

  /* end ATV */

  // Registrasi User 
  PostRegistrasiuser(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/adduser', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostChecksalescode(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checksalescode', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCheckusername(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checkusername', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCheckemail(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/checkemail', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostResetuser(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/resetuser', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostUpdateuser(params: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/updateuser/'+params, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostEdituser(params: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/edituser/'+params, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostDeleteuser(id: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/deleteuser/'+id, {}, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostSubmitdatasales(id: any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'usermanagement/users/submitdatasales/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  GetRole(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'master/auths/listrole',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetRoleSubPartner(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'master/auths/listrolesubpartner',this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }  

  getApipagelistpartner(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'apipage/partners/listpartner', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  postAddpartner(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'apipage/partners/addpartner', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  postManageby(id:any, data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'apipage/partners/manageby/'+id, JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  Partnerfromlogin(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'apipage/partners/partnerfromlogin', this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  
  // web purchase
  GetWPSearch(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'webpurchase/actions/search', JSON.stringify(data), this._outhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  GetWPProdaddon(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'webpurchase/actions/productaddon', JSON.stringify(data), this._outhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  GetWPOutstanding(data: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'partner/customers/outstanding/'+data, this._outhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostWPCheckout(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'webpurchase/actions/checkout', JSON.stringify(data), this._outhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostWPWaNotif(data: any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'webpurchase/actions/wanotif', JSON.stringify(data), this._outhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  bill(data:any): Observable<any> {
    return this.http.post<any>("https://billing.mncplay.id/main/billinfo", JSON.stringify(data), this._billhttpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  

  // playbox store
  // GET List order
  GetPlayboxOrder(params: any): Observable<Customer> {
    return this.http.get<Customer>(this.urlApi + 'storeplaybox/actions/order'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetViewPlayboxOrder(id): Observable<any> {
    return this.http.get<any>(this.urlApi + 'storeplaybox/actions/detorder/' +id, this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostAddTicketValsys(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'storeplaybox/actions/addticketvalsys', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
    // Store Shop
  GetListStoreshop(params: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'storeplaybox/storeshops/list'+params,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetDetailStoreshop(id: any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'storeplaybox/storeshops/detail/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostCreateStoreShop(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'storeplaybox/storeshops/create', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  PostUpdateStoreShop(id : any,data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'storeplaybox/storeshops/update/'+id, JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostUploadFileResi(data): Observable<any> {
    return this.http.post<any>(this.urlApi + 'storeplaybox/actions/uploadimage', data, this._httpUploadOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostUploadFileResidummy(data): Observable<any> {
    return this.http.post<any>('http://localhost/api-open-content/frontend/web/uploadd.php', data)
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  // Playbox ATV Controller Module
  // Parental Control
  Checksncust(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/checksncust', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Resetpin(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/resetpin', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Turnoffpin(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/turnoffpin', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  // Playbox Information
  Getcustcategory(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getcustcategory', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getlistinfo(params:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getlistinfo'+params, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Addinfo(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/addinfo', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Setinfo(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/setinfo/'+id, JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Deleteinfo(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/deleteinfo/'+id, {}, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getinfodetail(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getinfodetail/'+id, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  // Playbox Message
  Getmessagetype(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getmessagetype', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getlistmessage(params:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getlistmessage'+params, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Addmessage(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/addmessage', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Setmessage(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/setmessage/'+id, JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Deletemessage(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/deletemessage/'+id, {}, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getmessagedetail(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getmessagedetail/'+id, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Listcustomerplaybox(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/listcustomer', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Listcustomermessage(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/listcustomermessage', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  // Playbox Message
  Getlistrunningtext(params:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getlistrunningtext'+params, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getrunningtexttype(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getrunningtexttype', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getrunningtextdetail(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'playboxatv/playboxes/getrunningtextdetail/'+id, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Addrunningtext(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/addrunningtext', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Setrunningtext(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/setrunningtext/'+id, JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Deleterunningtext(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'playboxatv/playboxes/deleterunningtext/'+id, {}, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  
  // Playbox Promo
  Gettenor(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'promo/promos/tenorx', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getpromocategory(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'promo/promos/promocategoryx', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Getpromolist(params:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'promo/promos/getpromolist'+params, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Viewpromodetail(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'promo/promos/viewpromodetail/'+id, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Addpromo(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'promo/promos/addpromo', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Updatepromo(id:any, data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'promo/promos/updatepromo/'+id, JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Deletepromo(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'promo/promos/deletepromo/'+id, {}, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  /* summary cicilan */

  Viewsummaryinstallment(qstring:string): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/summary'+qstring, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Viewsummarycustomercicilan(qstring:string): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/customercicilan'+qstring, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Viewsummarydetailcicilan(qstring:any, detailpost:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'reporting/cicilans/detailcicilan'+qstring, JSON.stringify(detailpost), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Viewsummaryinstallmentbyaging(qstring:string): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/outstandingaging'+qstring, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Viewsummaryinstallmentbyagingdetail(qstring:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/detailaging'+qstring, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }
  Exportcicilansummary(): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/exportcicilan', this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  Exportdetailoutstanding(param:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'reporting/cicilans/exportoutstanding'+param, this._httpOptions())
  }

  /* dismantle */
  
  GetListcandidatedismantle(qstring:string): Observable<any> {
    return this.http.get<any>(this.urlApi + 'dismantle/dismantles/kandidat'+qstring, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }


  Postsubmitdismantle(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'dismantle/dismantles/submit', data, this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
  }

  PostUploadVoucher(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'productvoucher/uploadvouchers/draft', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  PostReUploadVoucher(id:any, data: any): Observable<any> {
    console.log(JSON.stringify(data))
    return this.http.post<any>(this.urlApi + 'productvoucher/uploadvouchers/reuploaddraft', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  

  GetBatchuploadvoucer(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/uploadvouchers/detailbatch/'+id,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListdraftvoucer(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/uploadvouchers/listdraft/'+id,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListvoucher(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/vouchers/list/'+id,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  GetAllListvoucher  (qs): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/vouchers/alllist?'+qs,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListbatchvoucher(id:any): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/vouchers/listbatch/'+id,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetListtransaksi(qstring:string): Observable<any> {
    return this.http.get<any>(this.urlApi + 'productvoucher/vouchers/transaksi'+qstring,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  
  Postdeletedraft(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/uploadvouchers/deletedraft', JSON.stringify({'id':id}), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostResendVoucher(id:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/vouchers/resend/'+id, JSON.stringify({}), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  PostSubmitBatchVoucher(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/uploadvouchers/submit', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostOrdermanualVoucher(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/vouchers/ordermanual', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  
  PostVoucherSetBook(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/vouchers/setbook', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostVoucherClearBook(data:any): Observable<any> {
    return this.http.post<any>(this.urlApi + 'productvoucher/vouchers/clearbook', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetProductvouchersummaryprod(id){
    return this.http.get<any>(this.urlApi + 'productvoucher/vouchers/summaryproduct/'+id,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  /* post pgw */
  PostPayment(data){
    return this.http.post<any>(this.urlApi + 'partner/customerservices/paidorderservicepgw', JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  /* sub partner */

  GetSubpartner(str){
    return this.http.get<any>(this.urlApi + 'partner/companies/listpartnersubdealer'+str,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetDroplistsub(str){
    return this.http.get<any>(this.urlApi + 'partner/companies/droplistsub'+str,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  
  
  PostAddSubpartner(data){
    return this.http.post<any>(this.urlApi + 'partner/companies/addsubdealer',  JSON.stringify(data), this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetStbSubpartner(str){
    return this.http.get<any>(this.urlApi + 'partner/companies/liststbsubdealer/'+str,  this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  GetSubPartnerCustomers(str) : Observable<any>{
    return this.http.get<any>(this.urlApi + 'partner/subpartners/customer'+str,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }
  GetPartnerapps(str) : Observable<any>{
    return this.http.get<any>(this.urlApi + 'partner/subpartners/partnerapp'+str,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  
  }

  GetServicesQuotaApps(str) : Observable<any>{
    return this.http.get<any>(this.urlApi + 'partner/subpartners/servicesapp'+str,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  
  }

  PostAppsCustomer(data: any): Observable<Customer> {
      return this.http.post<Customer>(this.urlApi + 'partner/subpartners/addcustomer', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }
  
  GetViewSubpartnerServiceQuota(id: any): Observable<ListStb> {
    return this.http.get<ListStb>(this.urlApi + 'partner/partners/viewservicequotabysubpartner/'+id,this._httpOptions())
    .pipe(
      retry(1),
      catchError(this.errorHandl)
    )
  }

  PostSwitchServices(data: any): Observable<any> {
      return this.http.post<any>(this.urlApi + 'partner/customerapps/switchservice', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }

  PostActivationApps(data: any): Observable<any> {
      return this.http.post<any>(this.urlApi + 'partner/customerapps/activation', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }  

  PostRepairingApps(data: any): Observable<any> {
      return this.http.post<any>(this.urlApi + 'partner/customerapps/repairing', JSON.stringify(data), this._httpOptions())
      .pipe(
        retry(1),
        catchError(this.errorHandl)
      )
    }    

    



  
  


  // Error handling
  errorHandl(error: any) {
     let errorMessage = '';
     if(error.error instanceof ErrorEvent) {
       // Get client-side error
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
     }
     console.log(errorMessage);
     return throwError(errorMessage);
  }

}
